import template from './sales-by-vendor.html';
import controller from './sales-by-vendor.controller';
import './sales-by-vendor.scss';

let SalesByVendorComponent = {
  bindings: {},
  template,
  controller
};

export default SalesByVendorComponent;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-vendor/sales-by-vendor.component.js